const INPUT_VARIANT = {
    Inner: "innerLabel",
    Outer: "outerLabel",
};

export { INPUT_VARIANT };
